(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csr-brand-search"] && !Shopify.designMode) return;
  try {
    
  class CSRBrandSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('input[type="search"]');
      this.status = this.querySelector('[role="status"]');
      this.clearButton = this.querySelector('.csr-brand-search__clear');
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        clearTimeout(this.timer);
        this.submit();
      }, options);
      this.input.addEventListener('input', () => {
        this.request?.abort();
        this.clearButton.hidden = !this.input.value;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.submit(), 450);
      }, options);
      this.clearButton.addEventListener('click', () => {
        this.input.value = '';
        clearTimeout(this.timer);
        this.submit();
        this.input.focus();
      }, options);
      window.addEventListener('popstate', () => {
        this.syncInput();
        this.refresh(new URL(location.href), false);
      }, options);
      document.addEventListener('click', event => {
        const link = event.target.closest?.('.pagination a, .main-collection-grid__empty-link');
        if (!link || !this.target?.contains(link) || !this.usesSearch(new URL(location.href))) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const url = new URL(link.href);
        url.pathname = this.dataset.collectionUrl;
        if (link.matches('.main-collection-grid__empty-link')) {
          url.search = '';
          this.input.value = '';
        }
        this.refresh(url, true).then(() => this.scrollIntoView({ block: 'start', behavior: 'instant' }));
      }, { ...options, capture: true });
      this.syncInput();
      if (this.dataset.catalog || this.input.value) this.refresh(new URL(location.href), false);
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.request?.abort();
      clearTimeout(this.timer);
      this.initialized = false;
    }
    get target() {
      return document.querySelector('main results-list')?.closest('.shopify-section');
    }
    syncInput() {
      this.input.value = new URL(location.href).searchParams.get('q') || '';
      this.clearButton.hidden = !this.input.value;
    }
    usesSearch(url) {
      return Boolean(this.dataset.catalog || url.searchParams.get('q')?.trim());
    }
    handlesSection(sectionId, url) {
      return this.target?.id === 'shopify-section-' + sectionId.replace(/^shopify-section-/, '') &&
        url.pathname === this.dataset.collectionUrl && this.usesSearch(url);
    }
    async fetchResults(sectionId, sourceURL, signal) {
      if (this.dataset.collectionSearch) return this.fetchCollectionResults(sectionId, sourceURL, signal);
      const url = new URL(sourceURL);
      const query = sourceURL.searchParams.get('q')?.trim() || '';
      url.pathname = this.dataset.searchUrl;
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      const size = ['24','36'].includes(url.searchParams.get('limit')) ? '-' + url.searchParams.get('limit') : '';
      url.searchParams.set('view', (this.dataset.catalog ? 'csr-catalog' : 'csr-brand') + size);
      url.searchParams.set('q', query || '*');
      url.searchParams.set('type', 'product');
      if (this.dataset.vendor) {
        url.searchParams.delete('filter.p.vendor');
        const vendors = this.dataset.vendors ? JSON.parse(this.dataset.vendors) : [this.dataset.vendor];
        for (const vendor of vendors) url.searchParams.append('filter.p.vendor', vendor);
      }
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('options[unavailable]', 'last');
      if (!['price-ascending', 'price-descending', 'relevance'].includes(url.searchParams.get('sort_by'))) url.searchParams.delete('sort_by');
      const loadResults = async () => {
        const response = await fetch(url, { signal });
        if (!response.ok) throw new Error('Brand search request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const marker = doc.querySelector('[data-csr-brand-results]');
        if (!marker) throw new Error('Brand search results missing');
        return marker;
      };
      let marker;
      if (/^[A-Za-z0-9][A-Za-z0-9._/-]*$/.test(query) && /\d/.test(query)) {
        url.searchParams.set('q', `(variants.sku:"${query}" OR variants.barcode:"${query}")`);
        url.searchParams.set('options[prefix]', 'none');
        marker = await loadResults();
        if (Number(marker.dataset.resultsCount) === 0) {
          url.searchParams.set('q', query);
          url.searchParams.set('options[prefix]', 'last');
          marker = await loadResults();
        }
      } else {
        marker = await loadResults();
      }
      const section = marker?.closest('.shopify-section');
      if (!section) throw new Error('Brand search results missing');
      const oldId = section.id.replace(/^shopify-section-/, '');
      for (const element of section.querySelectorAll('[href], [data-url]')) {
        for (const attribute of ['href', 'data-url']) {
          const value = element.getAttribute(attribute);
          if (!value || value.startsWith('#')) continue;
          const link = new URL(value, url);
          if (link.pathname !== this.dataset.searchUrl) continue;
          link.pathname = this.dataset.collectionUrl;
          for (const key of ['view', 'type', 'options[prefix]', 'options[unavailable]']) link.searchParams.delete(key);
          if (this.dataset.vendor) link.searchParams.delete('filter.p.vendor');
          if (query && link.searchParams.has('q')) link.searchParams.set('q', query);
          if (this.dataset.catalog && link.searchParams.get('q') === '*') link.searchParams.delete('q');
          const count = sourceURL.searchParams.get('limit');
          if (['12','24','36'].includes(count)) { link.searchParams.set('limit', count); link.searchParams.set('view', 'csr-' + count); }
          element.setAttribute(attribute, link.pathname + link.search);
        }
      }
      for (const input of section.querySelectorAll('input[name="q"]')) input.setAttribute('value', query);
      const empty = section.querySelector('.main-collection-grid__empty p');
      if (empty) empty.textContent = this.dataset.empty;
      return section.outerHTML.replaceAll(oldId, sectionId.replace(/^shopify-section-/, ''));
    }
    async fetchCollectionResults(sectionId, sourceURL, signal) {
      // Collection membership and ordering come from Shopify, including active filters.
      const baseURL = new URL(sourceURL);
      for (const key of ['q', 'page', 'section_id', 'sections']) baseURL.searchParams.delete(key);
      baseURL.searchParams.sort();
      const key = baseURL.href;
      this.collectionCache ||= new Map();
      let entry = this.collectionCache.get(key);
      if (!entry || Date.now() - entry.created > 60000) {
        const indexPage = async page => {
          const url = new URL(baseURL);
          url.searchParams.set('view', 'csr-search-index');
          url.searchParams.set('page', page);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Collection index unavailable');
          const data = JSON.parse(await response.text());
          if (!Array.isArray(data.products) || data.pages > 100) throw new Error('Invalid collection index');
          return data;
        };
        entry = { created: Date.now(), cards: new Map() };
        entry.index = (async () => {
          const first = await indexPage(1);
          const products = first.products;
          for (let page = 2; page <= first.pages; page += 4) {
            const batch = await Promise.all(Array.from({ length: Math.min(4, first.pages - page + 1) }, (_, i) => indexPage(page + i)));
            products.push(...batch.flatMap(data => data.products));
          }
          return products;
        })().catch(error => { this.collectionCache.delete(key); throw error; });
        this.collectionCache.set(key, entry);
        if (this.collectionCache.size > 6) this.collectionCache.delete(this.collectionCache.keys().next().value);
      }
      const loadPage = page => {
        if (!entry.cards.has(page)) {
          const url = new URL(baseURL);
          url.searchParams.set('page', page);
          url.searchParams.set('section_id', sectionId);
          entry.cards.set(page, fetch(url).then(async response => {
            if (!response.ok) throw new Error('Collection cards unavailable');
            return new DOMParser().parseFromString(await response.text(), 'text/html');
          }).catch(error => { entry.cards.delete(page); throw error; }));
        }
        return entry.cards.get(page);
      };
      const [products, firstPage] = await Promise.all([entry.index, loadPage(1)]);
      signal?.throwIfAborted();
      const section = firstPage.getElementById('shopify-section-' + sectionId)?.cloneNode(true);
      const results = section?.querySelector('results-list');
      if (!results) throw new Error('Collection grid missing');
      const nativePerPage = Number(results.dataset.csrPageSize) || 12;
      const requestedSize = Number(sourceURL.searchParams.get('limit'));
      const perPage = [12,24,36].includes(requestedSize) ? requestedSize : 12;
      const query = sourceURL.searchParams.get('q').trim().toLowerCase();
      const normalize = value => String(value || '').toLowerCase();
      const indexed = products.map((product, i) => ({ ...product, page: Math.floor(i / nativePerPage) + 1 }));
      const identifiers = indexed.filter(product => [...product.sku, ...product.barcode].some(value => normalize(value).includes(query)));
      const terms = query.split(/\s+/).filter(Boolean);
      const isPartNumber = /^[a-z0-9][a-z0-9._/-]*$/.test(query) && /\d/.test(query);
      const matches = isPartNumber && identifiers.length ? identifiers : indexed.filter(product => {
        const text = normalize([product.text, ...product.tags, ...product.sku, ...product.barcode].join(' '));
        return terms.every(term => text.includes(term));
      });
      const pages = Math.max(1, Math.ceil(matches.length / perPage));
      const page = Math.max(1, Math.min(pages, Number(sourceURL.searchParams.get('page')) || 1));
      const visible = matches.slice((page - 1) * perPage, page * perPage);
      const nativePages = [...new Set(visible.map(product => product.page))];
      for (let i = 0; i < nativePages.length; i += 4) {
        await Promise.all(nativePages.slice(i, i + 4).map(loadPage));
        signal?.throwIfAborted();
      }
      results.setAttribute('infinite-scroll', 'false');
      for (const element of section.querySelectorAll('.pagination, [ref="viewMorePrevious"], [ref="viewMoreNext"]')) element.remove();
      const grid = section.querySelector('.product-grid');
      if (grid) {
        grid.replaceChildren();
        grid.dataset.lastPage = pages;
        for (const [i, product] of visible.entries()) {
          const doc = await loadPage(product.page);
          const original = doc.querySelector('li[data-product-id="' + product.id + '"]');
          if (!original) throw new Error('Collection changed during search; retry');
          // Native card component IDs use page positions; make them unique after merging pages.
          const ids = [...original.querySelectorAll('[id]')].map(element => element.getAttribute('id')).filter(Boolean).sort((a, b) => b.length - a.length);
          const template = document.createElement('template');
          const pattern = ids.map(id => id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
          template.innerHTML = pattern ? original.outerHTML.replace(new RegExp(pattern, 'g'), id => id + '-csr-' + product.id) : original.outerHTML;
          const card = template.content.firstElementChild;
          card.className = 'product-grid__item product-grid__item--' + i;
          card.dataset.page = page;
          grid.append(card);
        }
        if (!matches.length) {
          const empty = document.createElement('div');
          empty.className = 'main-collection-grid__empty';
          const heading = document.createElement('h2');
          heading.className = 'main-collection-grid__empty-title h2';
          heading.textContent = this.dataset.noResults;
          const message = document.createElement('p');
          message.textContent = this.dataset.empty;
          empty.append(heading, message);
          grid.replaceWith(empty);
        } else if (pages > 1) {
          const nav = document.createElement('nav');
          nav.className = 'pagination';
          nav.setAttribute('aria-label', this.dataset.paginationLabel);
          nav.dataset.current_page = page;
          const list = document.createElement('ul');
          list.className = 'pagination__list';
          const numbers = [...new Set([1, page - 1, page, page + 1, pages])].filter(n => n >= 1 && n <= pages).sort((a, b) => a - b);
          let previous = 0;
          for (const number of numbers) {
            if (previous && number > previous + 1) {
              const gap = document.createElement('li');
              gap.className = 'pagination__item';
              gap.textContent = '…';
              list.append(gap);
            }
            const item = document.createElement('li');
            item.className = 'pagination__item';
            const link = document.createElement('a');
            link.className = 'pagination__link';
            const url = new URL(sourceURL);
            url.searchParams.set('page', number);
            link.href = url.pathname + url.search;
            link.textContent = number;
            if (number === page) link.setAttribute('aria-current', 'page');
            item.append(link);
            list.append(item);
            previous = number;
          }
          nav.append(list);
          grid.after(nav);
        }
      }
      const toolbar = section.querySelector('csr-page-size');
      if (toolbar) {
        const start = matches.length ? (page - 1) * perPage + 1 : 0;
        const end = Math.min(page * perPage, matches.length);
        toolbar.querySelector('p').textContent = toolbar.dataset.range.replace('__FIRST__', start).replace('__LAST__', end).replace('__TOTAL__', matches.length);
        for (const option of toolbar.querySelectorAll('option')) {
          option.toggleAttribute('selected', Number(option.value) === perPage);
        }
      }
      const count = this.dataset.resultLabel.replace('__COUNT__', matches.length);
      for (const element of section.querySelectorAll('[data-testid="products-count"] [role="status"], .facets__see-results')) element.textContent = count;
      for (const element of section.querySelectorAll('[data-results-count]')) element.dataset.resultsCount = matches.length;
      return section.outerHTML;
    }
    submit() {
      const url = new URL(location.href);
      const query = this.input.value.trim();
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      if (this.dataset.vendor) url.searchParams.delete('filter.p.vendor');
      if (query) url.searchParams.set('q', query);
      else {
        url.searchParams.delete('q');
        if (url.searchParams.get('sort_by') === 'relevance') url.searchParams.delete('sort_by');
      }
      this.refresh(url, true);
    }
    async refresh(url, updateHistory) {
      const target = this.target;
      if (!target) return;
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      this.status.textContent = this.dataset.loading;
      this.setAttribute('aria-busy', 'true');
      this.clearButton.hidden = !this.input.value;
      try {
        const sectionId = target.id.replace(/^shopify-section-/, '');
        let html;
        if (this.usesSearch(url)) html = await this.fetchResults(sectionId, url, request.signal);
        else {
          const requestURL = new URL(url);
          requestURL.searchParams.set('section_id', sectionId);
          const response = await fetch(requestURL, { signal: request.signal });
          if (!response.ok) throw new Error('Collection request failed');
          html = await response.text();
        }
        if (request.signal.aborted) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const replacement = doc.getElementById(target.id);
        if (!replacement) throw new Error('Product grid missing');
        if (updateHistory) history.pushState({}, '', url.pathname + url.search);
        target.replaceWith(replacement);
        this.status.textContent = '';
        this.syncInput();
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('Collection search failed:', error);
          this.status.textContent = this.dataset.error;
        }
      } finally {
        if (this.request === request) this.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('csr-brand-search')) customElements.define('csr-brand-search', CSRBrandSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csr-collection-heading"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('csr-collection-description')) {
    customElements.define('csr-collection-description', class extends HTMLElement {
      connectedCallback() {
        this.preview = this.querySelector('.csr-collection-description__preview');
        this.full = this.querySelector('.csr-collection-description__full');
        this.button = this.querySelector('button');
        this.expanded = false;
        this.lifecycle = new AbortController();
        this.button.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.render();
          if (!this.expanded) {
            requestAnimationFrame(() => {
              const rect = this.button.getBoundingClientRect();
              if (rect.top < 0 || rect.bottom > window.innerHeight) {
                this.button.scrollIntoView({ block: 'nearest' });
              }
            });
          }
        }, { signal: this.lifecycle.signal });
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.previousWidth) {
            this.previousWidth = width;
            this.measure();
          }
        });
        this.observer.observe(this);
        this.measure();
        document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      }
      measure() {
        this.preview.hidden = false;
        this.truncated = this.preview.scrollHeight > this.preview.clientHeight + 1;
        this.render();
      }
      render() {
        const collapsed = this.truncated && !this.expanded;
        this.preview.hidden = !collapsed;
        this.full.hidden = collapsed;
        this.button.hidden = !this.truncated;
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.button.textContent = collapsed ? this.dataset.expandLabel : this.dataset.collapseLabel;
      }
      disconnectedCallback() {
        this.lifecycle?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csr-vehicle-fitment"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('csr-fitment')) return;
  const catalogCache = new Map();
  const productCache = new Map();
  class CsrFitment extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.requestId = 0;
      this.collectionHandle = this.dataset.collectionHandle || (this.dataset.mode === 'results' ? new URL(location.href).searchParams.get('collection') || '' : '');
      this.collectionTitle = this.dataset.collectionTitle || '';
      this.dataset.state = 'idle';
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.status = this.querySelector('[data-status]');
      this.results = this.querySelector('[data-results]');
      this.form = this.querySelector('form');
      this.year = this.querySelector('[name="year"]');
      this.make = this.querySelector('[name="make"]');
      this.model = this.querySelector('[name="model"]');
      this.submit = this.querySelector('[type="submit"]');
      this.filtersForm = this.querySelector('[data-filters]');
      this.selectedBrands = new Set();
      this.resultPage = 1;
      this.sortControl = this.querySelector('[data-sort]');
      this.pageSize = this.querySelector('[data-page-size]');
      this.sortControl?.addEventListener('change', () => this.applyFilters());
      this.pageSize?.addEventListener('change', () => this.applyFilters());
      this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {
        this.dataset.view = button.dataset.view;
        this.querySelectorAll('[data-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      this.querySelector('[data-change-vehicle]')?.addEventListener('click', () => {
        const bar = this.querySelector('.csr-fitment__bar');
        bar.hidden = !bar.hidden;
        this.querySelector('[data-change-vehicle]').setAttribute('aria-expanded', String(!bar.hidden));
        this.querySelector('[data-change-vehicle]').textContent = bar.hidden ? this.labels.change_vehicle : this.labels.hide_vehicle;
        if (!bar.hidden) this.year.focus();
      });
      this.querySelector('[data-brand-options]')?.addEventListener('change', event => {
        const input = event.target;
        if (!input.matches('input[type="checkbox"]')) return;
        if (input.checked) this.selectedBrands.add(input.value); else this.selectedBrands.delete(input.value);
        this.applyFilters();
      });
      this.querySelector('[data-price-ranges]')?.addEventListener('change', event => {
        const ranges = {all:['',''],low:['','749.99'],mid:['750','1500'],high:['1500.01','']};
        const values = ranges[event.target.value];
        if (values) { this.minPrice.value = values[0]; this.maxPrice.value = values[1]; this.applyFilters(); }
        else this.minPrice.focus();
      });
      this.filtersPanel = this.querySelector('[data-filter-panel]');
      this.filterDisclosure = this.querySelector('[data-filter-disclosure]');
      if (this.filterDisclosure) {
        this.mobileLayout = matchMedia('(max-width: 760px)');
        this.updateFilterLayout = () => { this.filterDisclosure.open = !this.mobileLayout.matches; };
        this.updateFilterLayout();
        this.mobileLayout.addEventListener('change', this.updateFilterLayout);
      }
      this.keyword = this.querySelector('[name="keyword"]');
      this.brand = this.querySelector('[name="brand"]');
      this.minPrice = this.querySelector('[name="min_price"]');
      this.maxPrice = this.querySelector('[name="max_price"]');
      this.filtersForm?.addEventListener('submit', e => { e.preventDefault(); this.applyFilters(); });
      this.filtersForm?.addEventListener('keydown', e => {
        if (e.key === 'Enter' && !e.isComposing && e.target.matches('input')) { e.preventDefault(); this.applyFilters(); }
      });
      const scheduleFilters = () => {
        clearTimeout(this.filterTimer);
        this.filterTimer = setTimeout(() => {
          if (this.isConnected && this.dataset.state === 'results') this.applyFilters();
        }, 250);
      };
      this.keyword?.addEventListener('input', e => {
        clearTimeout(this.filterTimer);
        if (!e.isComposing) scheduleFilters();
      });
      this.keyword?.addEventListener('compositionstart', () => clearTimeout(this.filterTimer));
      this.keyword?.addEventListener('compositionend', scheduleFilters);
      this.brand?.addEventListener('change', () => { this.selectedBrands = new Set(this.brand.value ? [this.brand.value] : []); this.applyFilters(); });
      this.querySelector('[data-clear-filters]')?.addEventListener('click', () => {
        this.keyword.value = this.brand.value = this.minPrice.value = this.maxPrice.value = '';
        this.selectedBrands.clear();
        this.querySelector('[name="price_range"][value="all"]').checked = true;
        this.maxPrice.setCustomValidity('');
        this.applyFilters();
      });
      [this.minPrice,this.maxPrice].forEach(input => input?.addEventListener('input', () => {
        this.querySelector('[name="price_range"][value="custom"]').checked = true;
        scheduleFilters();
      }));
      this.form?.addEventListener('submit', e => { e.preventDefault(); this.search(); });
      this.year?.addEventListener('change', () => this.changeYear());
      this.make?.addEventListener('change', () => this.changeMake());
      this.model?.addEventListener('change', () => { this.clearResults(); this.submit.disabled = !this.model.value; });
      this.querySelector('[data-reset]')?.addEventListener('click', () => this.reset());
      this.load();
    }
    async load() {
      try {
        await this.loadCollectionScope();
        let data;
        const url = this.dataset.catalogUrl;
        if (url) {
          const parsed = new URL(url, location.href);
          if (parsed.protocol !== 'https:' || !(['cdn.shopify.com', location.hostname, 'www.circuitspecr.com'].includes(parsed.hostname))) throw new Error('Invalid catalog location');
          const response = await fetch(parsed.href, {credentials: 'omit'});
          if (!response.ok) throw new Error('Catalog unavailable');
          data = await response.json();
        } else {
          data = JSON.parse(this.querySelector('[data-catalog]').content.textContent);
        }
        this.records = this.validate(data);
        this.vehicles = data.vehicles || [];
        this.querySelector('[data-pilot]').hidden = this.dataset.showDraft !== 'true';
        if (this.dataset.mode === 'table') {
          this.dataset.state = 'message';
          const records = this.records.filter(r => r.handle === this.dataset.productHandle);
          this.querySelector('h2').textContent = this.labels.chart;
          this.form.hidden = true;
          this.querySelector('[data-reset]').hidden = true;
          if (!records.length) { this.hidden = true; return; }
          this.results.append(this.table(records));
          this.status.textContent = records.some(r => r.inferred) ? this.labels.modelYearNotice : this.labels.restrictions;
          return;
        }
        const years = new Set();
        for (const row of this.records) for (let year = row.start; year <= row.end; year++) years.add(year);
        for (const row of this.vehicles) row.years.forEach(year => years.add(year));
        this.options(this.year, [...years].sort((a,b) => b-a), this.labels.chooseYear);
        this.year.disabled = years.size === 0;
        this.options(this.make, [], this.labels.chooseMake);
        this.options(this.model, [], this.labels.chooseModel);
        this.status.textContent = years.size ? this.labels.ready : this.labels.empty;
        if (!years.size) this.dataset.state = 'message';
        if (this.dataset.mode === 'results') {
          const params = new URL(location.href).searchParams;
          if (['year', 'make', 'model'].some(key => params.has(key))) {
            this.year.value = params.get('year') || '';
            this.changeYear();
            this.make.value = params.get('make') || '';
            this.changeMake();
            this.model.value = params.get('model') || '';
            if (this.year.value && this.make.value && this.model.value) {
              this.submit.disabled = false;
              await this.search({restoreFilters:true});
            } else {
              this.dataset.state = 'message';
              this.status.textContent = this.labels.invalidVehicle;
            }
          }
        }
      } catch (error) {
        this.dataset.state = 'message';
        this.status.textContent = this.labels.error;
        this.year.disabled = this.make.disabled = this.model.disabled = this.submit.disabled = true;
      }
    }
    async loadCollectionScope() {
      if (!this.collectionHandle) return;
      if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(this.collectionHandle)) throw new Error('Invalid collection');
      const root = (this.dataset.storeRoot || '/').replace(/\/$/, '');
      const url = new URL(root + '/collections/' + this.collectionHandle, location.href);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (this.dataset.mode === 'results') {
        const detailsUrl = new URL(url);
        detailsUrl.searchParams.set('view', 'csr-vehicle-info');
        const response = await fetch(detailsUrl.href, {signal: AbortSignal.timeout(20000), cache: 'no-store'});
        if (!response.ok) throw new Error('Collection unavailable');
        const details = JSON.parse(await response.text());
        if (details.handle !== this.collectionHandle || typeof details.title !== 'string' || !details.title.trim()) throw new Error('Collection unavailable');
        this.collectionTitle = details.title;
      }
      const label = this.querySelector('[data-collection-scope]');
      label.textContent = this.labels.collectionScope.replace('{collection}', this.collectionTitle);
      label.hidden = false;
      const back = this.querySelector('.csr-fitment__back');
      if (back) {
        back.href = url.href;
        back.textContent = '← ' + this.labels.backCollection.replace('{collection}', this.collectionTitle);
      }
    }
    validate(data) {
      if (data.version === 3) {
        if (Array.isArray(data.rows) && Array.isArray(data.strings)) {
          data = {...data,fitments:data.rows.map(row => {
            if (!Array.isArray(row) || row.length !== 7 || row.slice(2).some(i => !Number.isInteger(i) || typeof data.strings[i] !== 'string')) throw new Error('Invalid fitment row');
            return {start:row[0],end:row[1],make:data.strings[row[2]],model:data.strings[row[3]],handle:data.strings[row[4]],title:data.strings[row[5]],notes:data.strings[row[6]]};
          })};
        } else if (!Array.isArray(data.vehicles)) throw new Error('Invalid catalog');
      }
      if (![1,2,3].includes(data.version) || (!Array.isArray(data.fitments) && !Array.isArray(data.vehicles))) throw new Error('Invalid catalog');
      for (const r of data.fitments || []) {
        if (!Number.isInteger(r.start) || !Number.isInteger(r.end) || r.start < 1950 || r.end < r.start || r.end > new Date().getFullYear() + 2 || !r.make || !r.model || !r.title || !/^[a-z0-9_-]+$/.test(r.handle) || typeof r.notes !== 'string') throw new Error('Invalid fitment');
      }
      return data.fitments || [];
    }
    options(select, values, placeholder) {
      select.replaceChildren(new Option(placeholder, ''));
      values.forEach(value => select.add(new Option(String(value), String(value))));
    }
    selectedRows() {
      const year = Number(this.year.value);
      return this.records.filter(r => year >= r.start && year <= r.end);
    }
    selectedVehicles() {
      return this.vehicles.length ? this.vehicles.filter(r => r.years.includes(Number(this.year.value))) : this.selectedRows();
    }
    clearResults() {
      clearTimeout(this.filterTimer);
      this.dataset.state = 'idle';
      this.requestId++;
      this.results.replaceChildren();
      if (this.filtersForm) this.filtersForm.hidden = true;
      if (this.filtersPanel) this.filtersPanel.hidden = true;
      this.setListingVisible(false);
      const vehicleSummary = this.querySelector('[data-vehicle-summary]');
      if (vehicleSummary) vehicleSummary.hidden = true;
      this.querySelector('.csr-fitment__bar').hidden = false;
      this.status.textContent = this.labels.ready;
      const heading = this.querySelector('[data-results-heading]');
      if (heading) heading.textContent = this.labels.vehicleParts;
    }
    changeYear() {
      this.clearResults();
      this.options(this.make, [...new Set(this.selectedVehicles().map(r => r.make))].sort(), this.labels.chooseMake);
      this.options(this.model, [], this.labels.chooseModel);
      this.make.disabled = !this.year.value;
      this.model.disabled = this.submit.disabled = true;
    }
    changeMake() {
      this.clearResults();
      this.options(this.model, [...new Set(this.selectedVehicles().filter(r => r.make === this.make.value).map(r => r.model))].sort(), this.labels.chooseModel);
      this.model.disabled = !this.make.value;
      this.submit.disabled = true;
    }
    reset() {
      this.year.value = '';
      this.changeYear();
      if (this.dataset.mode === 'results') {
        const url = new URL(location.href);
        ['year','make','model','q','keyword','brand','min_price','max_price','sort_by','per_page','page'].forEach(key => url.searchParams.delete(key));
        history.replaceState(null, '', url);
      }
      this.year.focus();
    }
    node(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    productUrl(handle) {
      const root = this.dataset.storeRoot || '/';
      const url = new URL(`${root.replace(/\/$/, '')}/products/${handle}`, location.href);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    }
    table(records) {
      const wrap = this.node('div', 'csr-fitment__table-wrap');
      const table = this.node('table', 'csr-fitment__table');
      const caption = this.node('caption', 'csr-fitment__sr', this.labels.chart);
      table.append(caption);
      const head = this.node('thead');
      const headerRow = this.node('tr');
      [this.labels.year, this.labels.make, this.labels.model].forEach(label => {
        const th = this.node('th', '', label); th.scope = 'col'; headerRow.append(th);
      });
      head.append(headerRow); table.append(head);
      const body = this.node('tbody');
      const rows = new Map();
      records.forEach(r => {
        for (let year = r.start; year <= r.end; year++) rows.set(JSON.stringify([year,r.make,r.model]), [year,r.make,r.model]);
      });
      [...rows.values()].sort((a,b)=> b[0]-a[0] || a[1].localeCompare(b[1]) || a[2].localeCompare(b[2])).forEach(r => {
        const tr = this.node('tr'); r.forEach(v => tr.append(this.node('td', '', v))); body.append(tr);
      });
      table.append(body); wrap.append(table); return wrap;
    }
    async loadProducts(handles) {
      const missing = handles.filter(handle => !productCache.has(handle) || Date.now() - productCache.get(handle).loadedAt > 60000);
      const batches = [];
      for (let i=0; i<missing.length; i+=20) batches.push(missing.slice(i,i+20));
      let next = 0;
      await Promise.all(Array.from({length:Math.min(4,batches.length)}, async () => {
        while (next < batches.length) {
          const batch = batches[next++];
          const url = new URL(this.dataset.endpoint, location.href);
          url.searchParams.set('view','csr-product-meta');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id',preview);
          const collected = new Map();
          let pending = batch;
          let page = 1;
          while (pending.length) {
          url.searchParams.set('q',pending.join('|'));
          url.searchParams.set('page',String(page));
          const response = await fetch(url.href,{signal:AbortSignal.timeout(20000),cache:'no-store'});
          if (!response.ok) throw new Error('Product details unavailable');
          const payload = JSON.parse(await response.text());
          if (!Array.isArray(payload.products) || payload.products.length !== pending.length) throw new Error('Incomplete product details');
          const remaining = [];
          for (let i=0;i<pending.length;i++) {
            const product = payload.products[i];
            const handle = pending[i];
            if (product === null) { collected.set(handle,null); continue; }
            if (product.handle !== handle || typeof product.brand !== 'string' || !Number.isFinite(product.price) || product.price < 0 || product.variantPage !== page || !Array.isArray(product.identifiers) || product.identifiers.some(value => value !== null && typeof value !== 'string') || (product.nextVariantPage !== null && product.nextVariantPage !== page+1)) throw new Error('Invalid product details');
            const identifiers = [...(collected.get(handle)?.identifiers || []), ...product.identifiers.filter(value => value?.trim())];
            collected.set(handle,{...product,identifiers});
            if (product.nextVariantPage !== null) remaining.push(handle);
          }
          pending = remaining;
          page++;
          if (pending.length && page > 500) throw new Error('Too many variant pages');
          }
          for (const [handle,product] of collected) productCache.set(handle,{loadedAt:Date.now(),product});
        }
      }));
      return new Map(handles.map(handle => [handle,productCache.get(handle)?.product]));
    }
    async search({restoreFilters=false} = {}) {
      clearTimeout(this.filterTimer);
      if (!this.year.value || !this.make.value || !this.model.value) return;
      const filterParams = restoreFilters ? new URL(location.href).searchParams : new URLSearchParams();
      const vehicle = `${this.year.value} ${this.make.value} ${this.model.value}`;
      if (this.dataset.endpoint && this.dataset.mode !== 'table') {
        const destination = new URL(this.dataset.endpoint, location.href);
        destination.searchParams.set('view', 'vehicle');
        destination.searchParams.set('type', 'product');
        destination.searchParams.set('q', vehicle);
        destination.searchParams.set('year', this.year.value);
        destination.searchParams.set('make', this.make.value);
        destination.searchParams.set('model', this.model.value);
        if (this.collectionHandle) destination.searchParams.set('collection', this.collectionHandle);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        if (this.dataset.mode === 'finder') {
          location.assign(destination.href);
          return;
        }
        history.replaceState(null, '', destination.href);
        this.querySelector('[data-results-heading]').textContent = this.labels.partsFor.replace('{vehicle}', vehicle);
      }
      const requestId = ++this.requestId;
      if (this.dataset.endpoint) {
        this.dataset.state = 'message';
        this.status.textContent = this.labels.loadingResults;
        this.submit.disabled = true;
        this.results.replaceChildren();
        this.setListingVisible(false);
        if (this.filtersForm) this.filtersForm.hidden = true;
        if (this.filtersPanel) this.filtersPanel.hidden = true;
        try {
          const url = new URL(this.dataset.endpoint, location.href);
          url.searchParams.set('view', 'csr-fitment');
          url.searchParams.set('q', this.make.value.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const key = url.href;
          if (!catalogCache.has(key)) catalogCache.set(key, fetch(key, {signal: AbortSignal.timeout(20000)}).then(async response => {
            if (!response.ok) throw new Error('Catalog unavailable');
            return JSON.parse(await response.text());
          }).catch(error => { catalogCache.delete(key); throw error; }));
          const data = await catalogCache.get(key);
          if (requestId !== this.requestId) return;
          this.records = this.validate(data);
        } catch(error) {
          if (requestId === this.requestId) { this.status.textContent = this.labels.error; this.submit.disabled = false; }
          return;
        }
      }
      if (requestId !== this.requestId) return;
      const records = this.selectedRows().filter(r => r.make === this.make.value && r.model === this.model.value);
      const products = new Map();
      records.forEach(r => {
        if (!products.has(r.handle)) products.set(r.handle, []);
        products.get(r.handle).push(r);
      });
      try {
        if (this.filtersForm) {
          this.status.textContent = this.labels.loadingPrices;
          this.productDetails = await this.loadProducts([...products.keys()]);
          if (requestId !== this.requestId) return;
          for (const handle of products.keys()) {
            const details = this.productDetails.get(handle);
            if (!details) { products.delete(handle); continue; }
            if (this.collectionHandle && this.collectionHandle !== 'all') {
              if (!Array.isArray(details.collections)) throw new Error('Collection membership unavailable');
              if (!details.collections.includes(this.collectionHandle)) products.delete(handle);
            }
          }
          const brandNames = new Map();
          const brandAliases = {'ap r performance':'APR Performance','apr performnace':'APR Performance','p2m':'P2M (Phase 2 Motortrend)','phase 2 motortrend':'P2M (Phase 2 Motortrend)','riaction performance shocks':'Riaction'};
          for (const handle of products.keys()) {
            const details = this.productDetails.get(handle);
            const brand = details.brand.trim();
            this.productDetails.set(handle,{...details,brand:brandAliases[brand.toLowerCase()] || brand});
          }
          const names = [...products.keys()].map(handle => this.productDetails.get(handle).brand.trim()).sort((a,b)=>a.localeCompare(b));
          for (const name of names) if (!brandNames.has(name.toLowerCase())) brandNames.set(name.toLowerCase(),name);
          for (const handle of products.keys()) {
            const details = this.productDetails.get(handle);
            this.productDetails.set(handle,{...details,brand:brandNames.get(details.brand.trim().toLowerCase())});
          }
        }
      } catch(error) {
        if (requestId === this.requestId) { this.status.textContent = this.labels.priceLoadError; this.submit.disabled = false; }
        return;
      }
      this.submit.disabled = false;
      this.dataset.state = 'results';
      this.vehicleLabel = vehicle;
      this.entries = [...products.entries()].sort((a,b) => a[1][0].title.localeCompare(b[1][0].title));
      if (this.filtersForm) {
        this.options(this.brand,[...new Set([...products.keys()].map(handle => this.productDetails.get(handle).brand).filter(Boolean))].sort((a,b)=>a.localeCompare(b)),this.labels.allBrands);
        this.brand.value = [...this.brand.options].find(option=>option.value.toLowerCase()===(filterParams.get('brand')||'').toLowerCase())?.value || '';
        this.selectedBrands = new Set(filterParams.getAll('brand').map(name => [...this.brand.options].find(option => option.value.toLowerCase() === name.toLowerCase())?.value).filter(Boolean));
        this.sortControl.value = ['title','price-ascending','price-descending'].includes(filterParams.get('sort_by')) ? filterParams.get('sort_by') : 'title';
        this.pageSize.value = ['8','12','24'].includes(filterParams.get('per_page')) ? filterParams.get('per_page') : '8';
        this.resultPage = Math.max(1, parseInt(filterParams.get('page'), 10) || 1);
        this.keyword.value = (filterParams.get('keyword') || '').slice(0,200);
        this.minPrice.value = filterParams.get('min_price') || '';
        this.maxPrice.value = filterParams.get('max_price') || '';
        this.maxPrice.setCustomValidity('');
        this.filtersForm.hidden = !products.size;
        this.filtersPanel.hidden = !products.size;
      }
      if (this.dataset.mode === 'results') {
        this.querySelector('[data-selected-vehicle]').textContent = vehicle;
        this.querySelector('[data-vehicle-summary]').hidden = false;
        this.querySelector('.csr-fitment__bar').hidden = true;
        this.querySelector('[data-change-vehicle]').setAttribute('aria-expanded', 'false');
        this.querySelector('[data-change-vehicle]').textContent = this.labels.change_vehicle;
        const range = !this.minPrice.value && !this.maxPrice.value ? 'all' : this.minPrice.value === '' && this.maxPrice.value === '749.99' ? 'low' : this.minPrice.value === '750' && this.maxPrice.value === '1500' ? 'mid' : this.minPrice.value === '1500.01' && this.maxPrice.value === '' ? 'high' : 'custom';
        this.querySelector(`[name="price_range"][value="${range}"]`).checked = true;
      }
      this.applyFilters({keepPage:true});
    }
    setListingVisible(visible) {
      ['[data-results-controls]','[data-pagination]','[data-listing-note]'].forEach(selector => {
        const element = this.querySelector(selector);
        if (element) element.hidden = !visible;
      });
    }
    renderBrands(entries) {
      const container = this.querySelector('[data-brand-options]');
      if (!container) return;
      const focused = container.contains(document.activeElement) ? document.activeElement.value : null;
      const counts = new Map();
      entries.forEach(([handle]) => {
        const brand = this.productDetails.get(handle).brand;
        if (brand) counts.set(brand, (counts.get(brand) || 0) + 1);
      });
      this.selectedBrands.forEach(brand => { if (!counts.has(brand)) counts.set(brand, 0); });
      container.replaceChildren();
      [...counts.entries()].sort((a,b) => a[0].localeCompare(b[0])).forEach(([brand,count]) => {
        const label = this.node('label','csr-fitment__brand-option');
        const input = this.node('input'); input.type = 'checkbox'; input.value = brand; input.checked = this.selectedBrands.has(brand);
        label.append(input, this.node('span','',brand), this.node('span','csr-fitment__brand-count',String(count)));
        container.append(label);
        if (focused === brand) input.focus({preventScroll:true});
      });
    }
    applyFilters({keepPage=false} = {}) {
      clearTimeout(this.filterTimer);
      let entries = [...(this.entries || [])];
      if (!keepPage) this.resultPage = 1;
      if (this.filtersForm) {
        this.maxPrice.setCustomValidity('');
        const error = this.querySelector('[data-filter-error]');
        error.hidden = true;
        this.minPrice.removeAttribute('aria-invalid');
        this.maxPrice.removeAttribute('aria-invalid');
        const invalid = [this.minPrice,this.maxPrice].find(input => !input.validity.valid);
        if (invalid) {
          invalid.setAttribute('aria-invalid','true');
          error.textContent = this.labels.priceInputError; error.hidden = false; return;
        }
        const min = this.minPrice.value === '' ? 0 : Math.round(Number(this.minPrice.value)*100);
        const max = this.maxPrice.value === '' ? Infinity : Math.round(Number(this.maxPrice.value)*100);
        if (min > max) {
          this.maxPrice.setAttribute('aria-invalid','true');
          error.textContent = this.labels.priceRangeError; error.hidden = false; return;
        }
        const terms = this.keyword.value.normalize('NFKC').toLowerCase().split(/\s+/).filter(Boolean);
        entries = entries.filter(([handle, rows]) => {
          const details = this.productDetails.get(handle);
          const searchText = `${details.title || rows.map(row => row.title).join(' ')} ${details.brand} ${(details.identifiers || []).join(' ')}`.normalize('NFKC').toLowerCase();
          return terms.every(term => searchText.includes(term)) && details.price >= min && details.price <= max;
        });
        this.renderBrands(entries);
        entries = entries.filter(([handle]) => !this.selectedBrands.size || this.selectedBrands.has(this.productDetails.get(handle).brand));
        if (this.sortControl.value === 'price-ascending') entries.sort((a,b) => this.productDetails.get(a[0]).price - this.productDetails.get(b[0]).price);
        if (this.sortControl.value === 'price-descending') entries.sort((a,b) => this.productDetails.get(b[0]).price - this.productDetails.get(a[0]).price);
        const url = new URL(location.href);
        url.searchParams.delete('brand');
        this.selectedBrands.forEach(brand => url.searchParams.append('brand',brand));
        if (this.sortControl.value !== 'title') url.searchParams.set('sort_by',this.sortControl.value); else url.searchParams.delete('sort_by');
        if (this.pageSize.value !== '8') url.searchParams.set('per_page',this.pageSize.value); else url.searchParams.delete('per_page');
        for (const input of [this.keyword,this.minPrice,this.maxPrice]) {
          const value = input.value.trim();
          if (value) url.searchParams.set(input.name,value); else url.searchParams.delete(input.name);
        }
        history.replaceState(null,'',url);
        const count = [this.keyword.value.trim(),this.minPrice.value,this.maxPrice.value].filter(Boolean).length + this.selectedBrands.size;
        this.querySelector('[data-filter-count]').textContent = count ? ` (${count})` : '';
      }
      this.results.replaceChildren();
      const total = this.entries?.length || 0;
      const keyword = this.keyword?.value.trim() || '';
      this.status.textContent = total ? (keyword ? (entries.length === 1 ? this.labels.one_search_result : this.labels.search_results).replace('{count}',entries.length).replace('{keyword}',keyword) : (entries.length === 1 ? this.labels.one_vehicle_result : this.labels.vehicle_results).replace('{count}',entries.length)) : this.labels.noMatches;
      this.setListingVisible(Boolean(total));
      if (total && !entries.length) this.results.append(this.node('p','csr-fitment__empty',this.labels.noFilteredResults));
      const chips = this.querySelector('[data-active-chips]');
      if (chips) {
        chips.replaceChildren(this.node('span','csr-fitment__chip',this.vehicleLabel));
        if (keyword) chips.append(this.node('span','csr-fitment__chip',keyword));
        this.selectedBrands.forEach(brand => chips.append(this.node('span','csr-fitment__chip',brand)));
      }
      const size = Number(this.pageSize?.value || 8);
      const pageCount = Math.max(1, Math.ceil(entries.length / size));
      this.resultPage = Math.min(this.resultPage, pageCount);
      const shown = (this.resultPage - 1) * size;
      const range = this.querySelector('[data-result-range]');
      if (range) range.textContent = this.labels.range.replace('{start}',entries.length ? shown+1 : 0).replace('{end}',Math.min(shown+size,entries.length)).replace('{total}',entries.length);
      const pageUrl = new URL(location.href);
      if (this.resultPage > 1) pageUrl.searchParams.set('page',this.resultPage); else pageUrl.searchParams.delete('page');
      history.replaceState(null,'',pageUrl);
      const fragment = document.createDocumentFragment();
      entries.slice(shown, shown + size).forEach(([handle, rows]) => {
        const storedRow = rows[0];
        const row = {...storedRow,title:this.productDetails?.get(handle)?.title || storedRow.title};
        const card = this.node('article', 'csr-fitment__product');
        const info = this.node('div', 'csr-fitment__product-info');

        const title = this.node('h3', 'csr-fitment__product-title');
        const titleLink = this.node('a', '', row.title); titleLink.href = this.productUrl(handle); title.append(titleLink); info.append(title);
        const product = this.productDetails?.get(handle);
        if (product) {
          const media = this.node('a','csr-fitment__media');
          media.href = this.productUrl(handle);
          media.setAttribute('aria-label',row.title);
          const fallback = () => media.replaceChildren(this.node('span','csr-fitment__image-placeholder',this.labels.imageUnavailable));
          let imageUrl;
          try { if (product.image) { const parsed = new URL(product.image,location.href); if (parsed.protocol === 'https:') imageUrl = parsed.href; } } catch(error) {}
          if (imageUrl) {
            const img = this.node('img','csr-fitment__image');
            img.alt = product.imageAlt || row.title;
            img.width = img.height = 400;
            img.loading = fragment.childElementCount < 4 ? 'eager' : 'lazy';
            img.decoding = 'async';
            img.addEventListener('error',fallback,{once:true});
            img.src = imageUrl;
            media.append(img);
          } else fallback();
          card.append(media);
          const meta = this.node('p','csr-fitment__product-meta');
          info.insertBefore(this.node('p','csr-fitment__brand',product.brand),title);
          const price = (product.varies ? this.labels.priceFrom+' ' : '') + product.priceLabel.replaceAll('&nbsp;',' ');
          meta.append(this.node('strong','csr-fitment__price',price));
          info.append(meta);
        }
        if (rows.some(r => r.inferred)) info.append(this.node('p', 'csr-fitment__note csr-fitment__model-match', this.labels.modelMatch));
        const notes = [...new Set(rows.map(r => r.notes).filter(Boolean))].join(' ');

        const details = this.node('details', 'csr-fitment__details');
        details.append(this.node('summary', '', this.labels.chart));
        if (notes) details.append(this.node('p', 'csr-fitment__note', notes));
        details.append(this.table(this.records.filter(r => r.handle === handle)));
        info.append(details); card.append(info);
        const link = this.node('a', 'csr-fitment__view', this.labels.viewProduct); link.href = this.productUrl(handle); info.append(link);
        fragment.append(card);
      });
      this.results.append(fragment);
      const pagination = this.querySelector('[data-pagination]');
      if (pagination) {
        pagination.replaceChildren();
        pagination.hidden = entries.length <= size;
        const addButton = (number,text,current=false) => {
          const button = this.node('button','csr-fitment__page',text);
          button.type = 'button';
          button.setAttribute('aria-label',text === String(number) ? this.labels.page.replace('{number}',number) : text);
          if (current) button.setAttribute('aria-current','page');
          button.addEventListener('click', () => {
            this.resultPage = number;
            this.applyFilters({keepPage:true});
            this.status.setAttribute('tabindex','-1');
            this.status.focus({preventScroll:true});
            this.status.scrollIntoView({block:'start',behavior:'instant'});
          });
          pagination.append(button);
        };
        if (this.resultPage > 1) addButton(this.resultPage-1,this.labels.previous);
        const pages = new Set([1,pageCount,this.resultPage-1,this.resultPage,this.resultPage+1]);
        let previous = 0;
        [...pages].filter(page => page > 0 && page <= pageCount).sort((a,b) => a-b).forEach(page => {
          if (previous && page-previous > 1) pagination.append(this.node('span','','…'));
          addButton(page,String(page),page === this.resultPage);
          previous = page;
        });
        if (this.resultPage < pageCount) addButton(this.resultPage+1,this.labels.next);
      }
    }
  }
  customElements.define('csr-fitment', CsrFitment);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  class CSRPageSize extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('select').addEventListener('change', event => {
        const size = event.target.value;
        if (!['12','24','36'].includes(size)) return;
        const url = new URL(location.href);
        url.searchParams.set('limit', size);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        if (url.pathname.includes('/collections/')) url.searchParams.set('view', 'csr-' + size);
        else if (url.searchParams.get('view')?.startsWith('csr-')) {
          const kind = url.searchParams.get('view').includes('catalog') ? 'catalog' : 'brand';
          url.searchParams.set('view', 'csr-' + kind + (size === '12' ? '' : '-' + size));
        }
        url.hash = 'ResultsList';
        location.assign(url.href);
      });
    }
  }
  if (!customElements.get('csr-page-size')) customElements.define('csr-page-size', CSRPageSize);


  } catch(e) { console.error(e); }
})();
})();
